module.exports = "/dist/assets/images/diagonalLines.svg";